import { FC, useEffect } from 'react';
import {
  Navigate,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useAuthByTokenMutation } from 'shared/api';
import { saveAuth } from 'shared/lib';
import { Suspender } from 'shared/ui';

const AuthByToken: FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { token } = useParams<{ token: string }>();
  const [auth] = useAuthByTokenMutation({
    onCompleted: ({ customAuth }) => {
      if (customAuth) {
        saveAuth({
          accessToken: customAuth.AccessToken,
          refreshToken: customAuth.RefreshToken,
          idToken: customAuth.IdToken,
          expires: Number(customAuth.ExpiresIn),
        });
      }
      navigate(`/${searchParams.get('to')}` || '/', { replace: true });
    },
  });

  useEffect(() => {
    if (token) {
      auth({ variables: { token } });
    }
  }, [token, auth]);

  if (!token) {
    return <Navigate to={`/${searchParams.get('to')}` || '/'} replace />;
  }

  return <Suspender />;
};

export default AuthByToken;
